'use client';

import { cn } from '@prickle/ui';
import { signIn } from 'next-auth/react';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export function SignInButton({ className, children }: Props) {
  const classes = cn('link', 'link-hover', className);
  return (
    <li className={classes} onClick={() => signIn()} role="menuitem">
      {children || 'Sign In'}
    </li>
  );
}
